// Ano letivo exibido nas páginas de ensino (calendários).
// Para virar o site para 2027: troque ANO_CALENDARIO para 2027 e coloque as
// imagens novas em public/assets/images/calendarios/2027/ com os MESMOS nomes
// (fund1a.png, fund1b.png, fund2a.png, fund2b.png, medio1.png, medio2.png).
export const ANO_CALENDARIO = 2026;

// Versão das imagens: aumente este número sempre que substituir uma imagem de
// calendário com o mesmo nome, para os navegadores baixarem a versão nova.
// (Antes era usado um timestamp a cada carregamento, o que impedia o cache e
// deixava as páginas mais lentas.)
export const VERSAO_IMAGENS = 1;

export const calendarioUrl = (arquivo) =>
  `assets/images/calendarios/${ANO_CALENDARIO}/${arquivo}?v=${VERSAO_IMAGENS}`;

// Ano das matrículas anunciado no destaque da página Matricule-se.
export const ANO_MATRICULAS = 2027;
